angular.module('dbl-analytics')
    .provider('dblAnalyticsProvider', function() {

    var settings = {
        attrPrefix:'dblAnalytics',
        knownEventActions: {
            PING: 'Session Ping'
        },
        knownEventCategories:  {
            SESSION: 'Session'
        }
    };

    var providers = [];


    var _this = {
        $get: ['$log', '$rootScope', '$location', function($log, $rootScope, $location) {

            var _this = {
                //expose settings values
                settings: settings,

                providers: providers,

                //add analytics logging provider
                //to limit events set options.categoryExceptionsList to array of event categories not to log
                addProvider: function(provider, options) {
                    options = angular.copy(options);
                    options.providerName = options.providerName || 'na';
                    options.categoryExceptions = {};
                    if(options && options.categoryExceptionsList && options.categoryExceptionsList.length > 0) {
                        options.categoryExceptions = _.object(_.map(options.categoryExceptionsList, function(category) {
                            return [category, true];
                        }));
                    }
                    delete options.categoryExceptionsList;
                    providers.push({provider: provider, options: options});
                },

                //analytics eventTrack
                //action - description of event captured
                //event object
                eventTrack: function(action, event) {
                    //todo implement
                    if(action && event) {
                        providers.forEach(function(p) {
                            //unless configured to ignore this category log it
                            if(!p.options.categoryExceptions || !(event.category in p.options.categoryExceptions)) {
                                $rootScope.$broadcast('dbl-debug', {provider: p.options.providerName, action: action, event: event});
                                p.provider.eventTrack(action, event);
                            }
                        });
                    }
                },

                //analytics pageTrack
                //page
                //event  object
                pageTrack: function(page, event, toParams, fromParams) {
                    //todo implement
                    if(page) {
                        event = event || {};
                        providers.forEach(function(p) {
                            //unless configured to ignore this category log it
                            if(!p.options.categoryExceptions || !(event.category in p.options.categoryExceptions)) {
                                $rootScope.$broadcast('dbl-debug', {provider: p.options.providerName, page: page, event: event});
                                p.provider.pageTrack(page, event, toParams, fromParams);
                            }
                        });
                    }
                }
           };

           return _this;
        }],

        settings: settings
    };

    return _this;
});
